import { useIntl } from "react-intl";
import { array, type InferType, lazy, object, string } from "yup";

export const useFormSchema = () => {
  const { formatMessage } = useIntl();

  return lazy((formValues) =>
    object({
      items: array(
        object({
          id: string(),
          name: string()
            .required(
              formatMessage({
                id: "priceList.createCustomItems.name.required",
                defaultMessage: "Please enter a name",
              }),
            )
            .test({
              name: "Unique",
              message: formatMessage({
                id: "priceList.createCustomItems.name.unique",
                defaultMessage: "Item names must be unique",
              }),
              test: (thisName, ctx) => {
                return !formValues.items.some(
                  (item: { id: string; name: string }) =>
                    item.name === thisName && item.id !== ctx.parent.id,
                );
              },
            }),
        }),
      )
        .compact((item) => !item.name)
        .default([]),
    }),
  );
};

export type FormData = InferType<ReturnType<typeof useFormSchema>>;
